<template>
  <div class="myMaterial">
    <el-alert
      v-if="alertConfig"
      :title="alertConfig.title"
      :type="alertConfig.type"
      :description="alertConfig.description"
      show-icon
      :closable="false"
    />
    <el-divider content-position="left">基础素材</el-divider>
    <div class="myMaterial_upload">
      <div>
        <span class="myMaterial_upload_type medium">视频</span>
        <materialItem :item="item" :info="videoInfo" className="materialItemSmall" v-if="detailsInfo.videoUrl && detailsInfo.videoStatus !== 3">
          <template #listRight>
            <div @click="toSeeVideo(detailsInfo, 'videoUrl')" class="right-title hand" :title="`${item.trueName}的形象`">{{item.trueName}}的形象</div>
            <div class="right-item">
              <span>上传时间：</span>
              <span>{{ $initTime(detailsInfo.videoUploadTime, 'yyyy-MM-DD HH:mm') }}</span>
            </div>
            <div class="right-item">
              <span>后台审核：</span>
              <span>{{ auditStatusMap[detailsInfo.videoStatus] }}</span>
            </div>
            <div class="right-item">
              <span>通过时间：</span>
              <span>{{ $initTime(detailsInfo.modifiedTime, 'yyyy-MM-DD HH:mm') }}</span>
            </div>
            <div class="right-item" :title="detailsInfo.videoRemarks" v-if="detailsInfo.videoStatus === 3">
              <span>审核失败原因：</span>
              <span>{{ detailsInfo.videoRemarks }}</span>
            </div>
            <div class="right-item" :title="`${detailsInfo.id}-${userId}-${setPinyin}`">
              <span>素材ID：</span>
              <span>{{ detailsInfo.id }}-{{ userId }}-{{ setPinyin }}</span>
            </div>
            <div class="right-button" v-if="detailsInfo.videoUrl && !detailsInfo.videoStatus">
              <el-button plain size="mini" @click="handleSubmit('Video')">
                提交
              </el-button>
            </div>
          </template>
        </materialItem>
        <template v-else>
          <el-popover
            trigger="hover"
            placement="top"
            width="auto"
            v-model="videoInfo.visible">
              <p>{{ videoInfo.ruleFileName }}</p>
              <div v-if="videoInfo.ruleFile" style="text-align: right; margin-top: 8px;">
                <el-button type="primary" size="mini" @click="handleDownload(videoInfo.ruleFile, videoInfo.ruleFileName)">下载</el-button>
              </div>
              <span class="myMaterial_guide_file" slot="reference">查看指导文件<el-icon class="el-icon-span el-icon-info" /></span>
          </el-popover>
          <upload :info="videoInfo" :fwId="detailsId" @successCallback="uploadMaterials"  />
        </template>
      </div>
      <div>
        <span class="myMaterial_upload_type medium">音频</span>
        <materialItem :item="item" :info="audioInfo" className="materialItemSmall" v-if="detailsInfo.voiceUrl && detailsInfo.voiceStatus !== 3">
          <template #listRight>
            <div @click="toSeeVideo(detailsInfo, 'voiceUrl')" class="right-title hand">{{item.trueName}}的声音</div>
            <div class="right-item">
              <span>上传时间：</span>
              <span>{{ $initTime(detailsInfo.voiceUploadTime, 'yyyy-MM-DD HH:mm') }}</span>
            </div>
            <div class="right-item">
              <span>后台审核：</span>
              <span>{{ auditStatusMap[detailsInfo.voiceStatus] }}</span>
            </div>
            <div class="right-item">
              <span>通过时间：</span>
              <span>{{ $initTime(detailsInfo.modifiedTime, 'yyyy-MM-DD HH:mm') }}</span>
            </div>
            <div class="right-item" v-if="detailsInfo.voiceStatus === 3">
              <span>审核失败原因：</span>
              <span>{{ detailsInfo.voiceRemarks }}</span>
            </div>
            <div class="right-item">
              <span>素材ID：</span>
              <span>{{ detailsInfo.id }}-{{ userId }}-{{ setPinyin }}</span>
            </div>
            <div class="right-button" v-if="detailsInfo.voiceUrl && !detailsInfo.voiceStatus">
              <el-button plain size="mini" @click="handleSubmit('Audio')">
                提交
              </el-button>
            </div>
          </template>
        </materialItem>
        <template v-else>
          <el-popover
            trigger="hover"
            placement="top"
            width="auto"
            v-model="audioInfo.visible">
              <p>{{ audioInfo.ruleFileName }}</p>
              <div v-if="audioInfo.ruleFile" style="text-align: right; margin-top: 8px;">
                <el-button type="primary" size="mini" @click="handleDownload(audioInfo.ruleFile, audioInfo.ruleFileName)">下载</el-button>
              </div>
              <span class="myMaterial_guide_file" slot="reference">查看指导文件<el-icon class="el-icon-span el-icon-info" /></span>
          </el-popover>
          <upload :isDisabled="detailsInfo.videoStatus === 2" :info="audioInfo" :fwId="detailsId" @successCallback="uploadMaterials" />
        </template>
      </div>
      <div>
        <span class="myMaterial_upload_type">授权文件</span>
        <materialItem :item="item" :info="fileInfo" className="materialItemSmall" v-if="detailsInfo.authorizeUrl">
          <template #listRight>
            <div @click="toSeeFile(detailsInfo, 'authorizeUrl')" class="right-title hand">{{item.trueName}}的授权文件</div>
            <div class="right-item">
              <span>上传时间：</span>
              <span>{{ $initTime(detailsInfo.modifiedTime, 'yyyy-MM-DD HH:mm') }}</span>
            </div>
            <div class="right-item">
              <span>ID：</span>
              <span>{{ detailsInfo.id }}-{{ userId }}-{{ setPinyin }}</span>
            </div>
            <div class="right-button" v-if="detailsInfo.authorizeUrl && detailsInfo.videoStatus !== 2">
              <el-popover
                placement="top"
                width="200"
                v-model="isDelete">
                <p>已提交授权书将被永久删除，是否确认删除？</p>
                <div style="text-align: right;">
                  <el-button size="mini" type="text" @click="isDelete = false">取消</el-button>
                  <el-button type="primary" size="mini" @click="handleReplaceFile">确定</el-button>
                </div>
                <el-button slot="reference" plain size="mini">
                  更换文件
                </el-button>
              </el-popover>
            </div>
          </template>
        </materialItem>
        <template v-else>
          <el-popover
            trigger="hover"
            placement="top"
            width="auto"
            v-model="fileInfo.visible">
              <p>{{ fileInfo.ruleFileName }}</p>
              <div v-if="fileInfo.ruleFile" style="text-align: right; margin-top: 8px;">
                <el-button type="primary" size="mini" @click="handleDownload(fileInfo.ruleFile, fileInfo.ruleFileName)">下载</el-button>
              </div>
              <span class="myMaterial_guide_file" slot="reference">查看指导文件<el-icon class="el-icon-span el-icon-info" /></span>
          </el-popover>
          <upload :info="fileInfo" :fwId="detailsId" @successCallback="uploadMaterials"  />
        </template>
      </div>
    </div>
    <el-divider content-position="left">模型素材</el-divider>
    <div class="myMaterial_model">
      <materialItem :info="videoInfo" :item="item" v-if="detailsInfo.aiVideoUrl">
        <template #listRight>
          <div @click="toSeeVideo(detailsInfo, 'aiVideoUrl')" class="right-title hand">{{item.trueName}}的AI数字人建模</div>
          <div class="right-item">
            <span>训练完成时间：</span>
            <span>{{$initTime(detailsInfo.aiModelUploadTime, 'yyyy-MM-DD HH:mm')}}</span>
          </div>
          <div class="right-item">
            <span>数字人ID：</span>
            <span>{{ detailsInfo.id }}-{{ detailsInfo.userId }}-{{ setPinyin }}</span>
          </div>
          <div class="right-item right-span">
            <span>审核状态：{{ userModelStatusMap[detailsInfo.userModelStatus] }}</span>
            <span v-if="detailsInfo.modifiedTime">审核时间：{{$initTime(detailsInfo.modifiedTime, 'yyyy-MM-DD HH:mm')}}</span>
          </div>
          <div class="right-item" v-if="detailsInfo.userModelStatus === 3">
            <span>原因：</span>
            <span>{{ detailsInfo.userModelRemarks }}</span>
          </div>
          <div class="right-button" v-if="detailsInfo.userModelStatus === 1">
            <el-button type="primary" @click="handleExamine(2)" size="mini" icon="el-icon-check">接受</el-button>
            <el-button type="danger" @click="handleNotExamine" plain size="mini" icon="el-icon-close">不接受</el-button>
            <el-button type="primary" @click="handleExamine(4)" plain size="mini">取消搁置</el-button>
            <span>说明：训练完成时间后，7日内您可以驳回或接受；超时将自动视为接受</span>
          </div>
        </template>
      </materialItem>
      <placeholder :isShow="true" content="AI训练结果待上传" v-else />
    </div>
    <!-- :fwId="lwId" :isShow.sync="isFwDetails" @updataList="updataList"
                     :verified="verified"  -->
    <notPassDialog :notPassDialogShow.sync="notPassDialogShow" :verified="3" @handleExamine="handleExamine" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { pinyin } from 'pinyin-pro'
import materialItem from './materialItem.vue'
import upload from './upload.vue'
import notPassDialog from './notPassDialog.vue'
import { getModelingDetails, uploadMaterials, addMaterialRecord } from '@/api/mySciencePopularization.js'
import { delFwFileInQn } from '@/api/lw.js'
import { getImageFormat, downloadFileByUrl } from '@/utils/index.js'
export default {
  props: {
    detailsId: {
      type: Number,
      default: null
    }
  },
  components: {
    materialItem,
    upload,
    notPassDialog
  },
  data () {
    return {
      videoInfo: {
        iconName: 'el-icon-video-camera',
        title: '视频',
        type: 'video',
        limit: 1,
        format: 'MP4/MOV',
        attention: '',
        guide: '录制指南：面部清晰无遮挡',
        guideIcon: 'el-icon-info',
        accept: 'video/mp4,video/quicktime',
        ruleFile: 'https://img.infox-med.com/aigc/%E8%AE%AD%E7%BB%83%E8%A7%86%E9%A2%91%E6%8B%8D%E6%91%84%E6%8C%87%E5%AF%BC%E6%96%87%E6%A1%A3.pdf',
        ruleFileName: '训练视频拍摄指导文档',
        visible: false
      },
      audioInfo: {
        iconName: 'el-icon-headset',
        title: '声音',
        type: 'audio',
        limit: 1,
        format: 'MP3/M4A/MAV',
        attention: '（拍摄形象时如有收音设备，可无需单独上传声音）',
        guide: '录制指南：声音清晰无杂音',
        guideIcon: 'el-icon-info',
        accept: 'audio/mpeg,audio/wav,audio/ogg,audio/flac,audio/x-m4a,.m4a',
        ruleFile: 'https://img.infox-med.com/aigc/%E9%9F%B3%E9%A2%91%E5%BD%95%E5%88%B6%E6%8C%87%E5%8D%97.zip',
        ruleFileName: '音频录制指南',
        visible: false
      },
      fileInfo: {
        iconName: 'el-icon-document',
        title: '授权文件',
        type: 'file',
        limit: 1,
        format: 'jpg/pdf',
        attention: '',
        guide: '点击下载模版，签字后拍照上传',
        guideIcon: 'el-icon-info',
        accept: 'image/png,image/jpeg,application/pdf,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        ruleFile: 'https://img.infox-med.com/aigc/%E5%BD%A2%E8%B1%A1%E6%8E%88%E6%9D%83%E4%BF%9D%E5%AF%86%E5%8D%8F%E8%AE%AE.pdf',
        ruleFileName: '形象授权保密协议',
        visible: false
      },
      item: {
        id: 0,
        trueName: ''
      },
      detailsInfo: {
      },
      auditStatusMap: ['待提交', '待审核', '审核通过', '审核失败'],
      userModelStatusMap: ['待上传', '待审核', '审核通过', '审核失败', '取消搁置'],
      notPassDialogShow: false,
      isDelete: false
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'userId']),
    setPinyin () {
      return pinyin(this.userInfo.trueName, { toneType: 'none', separator: '' })
    },
    alertConfig () {
      const { videoStatus, voiceStatus, videoRemarks, voiceRemarks, userModelStatus, userModelRemarks } = this.detailsInfo
      // 基础素材审核失败
      const videoFailed = videoStatus === 3
      const voiceFailed = voiceStatus === 3
      if (videoFailed || voiceFailed) {
        return {
          type: 'error',
          title: '素材审核失败',
          description: [
            videoFailed ? `视频：${videoRemarks}` : '',
            voiceFailed ? `音频：${voiceRemarks}` : ''
          ].filter(Boolean).join('；')
        }
      }

      // 基础素材待审核
      const videoPending = videoStatus === 1
      const voicePending = voiceStatus === 1
      if (videoPending || voicePending) {
        return {
          type: 'warning',
          title: '素材待审核',
          description: ''
        }
      }

      // 模型素材相关状态
      // 模型素材审核失败
      if (userModelStatus === 3) {
        return {
          type: 'error',
          title: '模型审核失败',
          description: userModelRemarks || 'AI数字人模型待优化'
        }
      }
      // 模型素材待确认
      if (userModelStatus === 1) {
        return {
          type: 'warning',
          title: '建模已生成，待确认',
          description: '请在7日内完成审核，超时将自动视为接受'
        }
      }
      // 模型素材审核通过
      if (userModelStatus === 2) {
        return {
          type: 'success',
          title: '专家审核通过',
          description: 'AI数字人模型已确认可用'
        }
      }

      // 基础素材审核通过
      const videoPassed = videoStatus === 2
      if (videoPassed) {
        return {
          type: 'success',
          title: '素材审核通过，建模中'
        }
      }
      return null
    }
  },
  methods: {
    async handleReplaceFile () {
      try {
        await uploadMaterials({
          id: this.detailsInfo.id,
          authorizeUrl: ''
        })
        this.$message.success('删除成功')
        delFwFileInQn(this.detailsInfo.authorizeUrl)
        this.detailsInfo.authorizeUrl = ''
        this.isDelete = false
      } catch (error) {
        this.$message.error(error || '删除失败')
      }
    },
    handleExamine (userModelStatus, userModelRemarks = '') {
      this.$confirm('提交后不可修改, 是否继续?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await uploadMaterials({
            ...this.detailsInfo,
            videoCheckTime: new Date().getTime(),
            voiceCheckTime: new Date().getTime(),
            userModelStatus,
            userModelRemarks
          })
          await addMaterialRecord({
            type: 1,
            itemId: this.detailsInfo.id,
            verified: userModelStatus,
            verifiedRecord: userModelRemarks,
            verifiedTime: new Date().getTime()
          })
          this.getModelingDetails()
          this.notPassDialogShow = false
          this.$message.success('操作成功')
        } catch (error) {
          this.$message.error(error)
        }
      }).catch((e) => {
      })
    },
    handleNotExamine () {
      this.notPassDialogShow = true
    },
    async uploadMaterials (task) {
      let materialBody = {}
      const type = task.submitConfig.fileType
      const url = task.submitConfig.fileUrl
      switch (type) {
        case 'Video':
          materialBody = { videoUrl: url, videoUploadTime: task.key, videoStatus: 0 }
          break
        case 'Audio':
          materialBody = { voiceUrl: url, voiceUploadTime: task.key, voiceStatus: 0 }
          break
        default:
          materialBody = { authorizeUrl: url }
          break
      }
      try {
        await uploadMaterials({
          id: this.detailsId,
          userId: this.userId,
          fileUploadTime: task.key,
          ...materialBody
        })
        this.getModelingDetails()
        this.$message.success('上传成功')
      } catch (error) {
        this.$message.error(error)
      }
    },
    handleSubmit (type) {
      let materialBody = {}
      switch (type) {
        case 'Video':
          materialBody = { videoStatus: 1, videoRemarks: '' }
          break
        case 'Audio':
          materialBody = { voiceStatus: 1, voiceRemarks: '' }
          break
        default:
          materialBody = { }
          break
      }
      this.$confirm('提交后不可修改, 是否继续?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
      }).then(async () => {
        try {
          await uploadMaterials({
            id: this.detailsInfo.id,
            ...materialBody
          })
          this.getModelingDetails()
          this.$message.success('提交成功')
        } catch (error) {
          this.$message.error(error)
        }
      }).catch((e) => {
      })
    },
    async getModelingDetails () {
      try {
        const { data } = await getModelingDetails({
          id: this.detailsId
        })
        this.detailsInfo = data || {}
      } catch (error) {
        this.$message.error(error)
      }
    },
    toSeeFile (item, type) {
      if (item[type].indexOf('.pdf') !== -1 || item[type].indexOf(`.${getImageFormat(item[type])}`) !== -1) {
        return window.open(item[type])
      }
      window.open(`https://view.officeapps.live.com/op/view.aspx?src=${item[type]}`)
    },
    toSeeVideo (video, type) {
      if (!this.userInfo.userId) {
        return this.$login()
      }
      sessionStorage.setItem('videoObj', JSON.stringify({
        videoId: video.id,
        videoUrl: video[type],
        modularType: 'video',
        tabActive: 0
      }))
      this.$router.push('/videoDetails')
    },
    handleDownload (url, name) {
      downloadFileByUrl(url, name)
    }
  },
  created () {
    this.getModelingDetails()
    this.item.trueName = JSON.parse(window.localStorage.getItem('userInfo')).trueName
  }
}
</script>
<style lang="less" scoped>
.myMaterial {
  overflow-y: auto;
  .el-divider__text{
    background: #F5F7FB;
  }
  .myMaterial_upload{
    display: flex;
    justify-content: space-between;
    >div{
      position: relative;
    }
    .myMaterial_guide_file{
      position: absolute;
      top: 5px;
      left: 6px;
      z-index: 1;
      color: #4b639f;
      cursor: pointer;
      .el-icon-span{
        margin-left: 2px;
        color: #f7ae53;
      }
    }
    .myMaterial_upload_type {
      position: absolute;
      top: 0;
      right: 0;
      background: linear-gradient(to bottom, #457DFF, #719CFF);
      color: white;
      padding: 0 12px;
      border-bottom-left-radius: 8px;
      border-top-right-radius: 8px;
      font-size: 14px;
      white-space: nowrap;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
      z-index: 1;
    }
    .medium {
      background: linear-gradient(to bottom, #A15FDE, #C386F0);
    }
  }
  .myMaterial_model{
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
}
</style>
